import React from 'react'
import { AppBar, Dialog, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';


const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    imgContainer: {
        position: 'relative',
        flex: 1,
        padding: 16,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    img: {
        maxWidth: '100%',
        maxHeight: '100%',
    },
}

function Transition(props) {
  return <Slide direction="up" {...props} />
}

class ImgDialog extends React.Component {
    state = {
        open: false,
    }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    render() {

        return (
        <Dialog
            fullScreen
            open={!!this.props.img}
            onClose={this.props.onClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={styles.appBar}>

            <Toolbar>

                <IconButton
                    color="inherit"
                    onClick={this.props.onClose}
                    aria-label="Close"
                >

                <CancelRoundedIcon />

                </IconButton>

                <Typography
                    variant="title"
                    color="inherit"
                    sx={styles.flex}
                >

                    Cropped image
                </Typography>

            </Toolbar>

            </AppBar>

            <div sx={styles.imgContainer}>

                <img src={this.props.img} alt="Cropped" style={styles.img} />

            </div>
        </Dialog>
        )
    }
}

export default ImgDialog
